var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWear2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.8803 32.7379L70.1542 44.1521C66.0587 45.1254 63.0756 38.5777 61.5208 37.7687C58.879 36.4036 62.6964 41.5608 63.4548 42.2307C65.6795 44.2153 68.7258 44.9863 71.1022 46.7307L74.692 66.1967L56.1108 71C55.1249 66.6518 54.5055 61.3302 52.976 57.1842C52.6473 56.2994 53.2035 56.0971 51.6361 56.2867C51.1052 58.7769 49.5126 69.8498 47.7935 70.7093L29.9707 66.4369C29.6294 65.3498 29.958 64.2628 30.0718 63.1883C30.274 61.3555 33.2066 47.2237 33.6743 46.4779C34.0788 45.8206 38.0478 44.7335 39.4509 43.7855C40.9298 42.7743 44.3806 39.4625 43.6475 37.7561C40.8793 40.1324 38.4776 44.3417 34.3695 44.1394L37.618 32.7L66.893 32.7252L66.8803 32.7379Z",
    fill: "#0256B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWear2);
export default __webpack_public_path__ + "static/media/wear2.332b4fd5236d8433b85f47972893c4ab.svg";
export { ForwardRef as ReactComponent };